import { combineReducers } from "redux";
import authReducer from "./Reducers/authReducer";
import menuReducer from "./Reducers/menuReducer";
import offersReducer from "./Reducers/offersReducer";
import usersReducer from "./Reducers/usersReducer";
import newsReducer from "./Reducers/newsReducer";
import eventsReducer from "./Reducers/eventsReducer";
import adminReducer from "./Reducers/adminReducer";
import groupsReducer from "./Reducers/groupsReducer";
import paginationReducer from "./Reducers/paginationReducer";
import cvsReducer from "./Reducers/cvsReducer";
import ressourcesReducer from "./Reducers/ressourcesReducer";
import universitiesReducer from "./Reducers/universitiesReducer";
import requestsReducer from "./Reducers/requestsReducer";
import messagesReducer from "./Reducers/messagesReducer";
import statesReducer from "./Reducers/statesReducer";
import secondaryTablesReducer from "./Reducers/secondaryTablesReducer";
import homeReducer from "./Reducers/homeReducer";

const rootReducer = combineReducers({
  auth: authReducer,
  items: menuReducer,
  offers: offersReducer,
  users: usersReducer,
  news: newsReducer,
  events: eventsReducer,
  admin: adminReducer,
  groups: groupsReducer,
  pagination: paginationReducer,
  cvs: cvsReducer,
  ressources: ressourcesReducer,
  universities: universitiesReducer,
  requests: requestsReducer,
  messages: messagesReducer,
  states: statesReducer,
  secondaryTables: secondaryTablesReducer,
  home: homeReducer,
});

export default rootReducer;
